import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";
import NavBarExt from "../components/NavBarExt";
import { isLoggedInUserInfo } from "./AuthState";
//import SingleMaterial from "../pages/SingleMaterial";

function ExternalRoutes() {
  //const { vendor, slug } = useParams();
  const { userInformation } = useContext(UserContext);
  const isLoggedIn = isLoggedInUserInfo(userInformation);

  return isLoggedIn ? (
    <>
      <NavBar />
      <Outlet />
    </>
  ) : (
    <>
      <NavBarExt />
      <Outlet />
    </>
  );
}

export default ExternalRoutes;
